export default __webpack_public_path__ + "static/media/arrow-right-dark.ef2ad2ec.svg";